import { t } from '../../../i18next';
import SetColumnConfig from '../../../shared/components/grid/SetColumnConfig';

export default function MOBSetColumnConfig(props) {
  const { gridColumns: columnsConfig } = SetColumnConfig(props);
  const gridColumns = columnsConfig.reduce((resp, item) => {
    if (item.attrInternalName === 'npi_mob') {
      item.onValueChange = (params) =>
        npiMobOnChange({
          ...params,
          ...props.customProps,
        });
    }
    if (item.attrInternalName === 'speedline_dec') {
      item.onValueChange = (params) =>
        speedlineDecisionOnChange({
          ...params,
          valueOptions: item.valueOptions,
          ...props.customProps,
        });
    }
    resp.push(item);
    return resp;
  }, []);
  return { gridColumns };
}

function speedlineDecisionOnChange(props) {
  const { rowId, value, updateRow, valueOptions } = props;
  const yesValue = valueOptions?.find((option) => {
    return String(option.label).trim().toLowerCase() === 'yes';
  })?.value;

  if (value === yesValue) {
    return;
  }

  updateRow({
    rowId,
    updatedFields: {
      speedline_plant: null,
      speedline_qty: null,
      speedline_due: null,
    },
  });
}

function npiMobOnChange(props) {
  const { row, value, setAlertbar } = props;
  if ((value == 12 || value == 13) && row.npi_accept_po) {
    setAlertbar({ children: t('mob.npiMobReject'), severity: 'warning', stopAutoClose: true });
    return false;
  }
  if (
    value === 2 &&
    row.bestellnummer &&
    row.npi_accept_po &&
    (row.nrp_due || row.rp_due || row.lumpsum_due || row.pag_deliverydate_due)
  ) {
    setAlertbar({
      children: t('mob.npiMobReIndustrialization'),
      severity: 'warning',
      stopAutoClose: true,
    });
    return false;
  }
}
